import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-lists',
  templateUrl: './pricing-lists.component.html',
  styleUrls: ['./pricing-lists.component.scss']
})
export class PricingListsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
